import styled from 'styled-components';

export const LatestVersion = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;

  p {
    color: ${({ theme }) => theme.palette.primary.main};
    font-size: 12px;
    margin: 0;
  }
`;

export const VersionButton = styled.button<{ $isActive?: boolean; $latestVersion?: boolean }>`
  display: block;
  width: 100%;
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey[100]};
  border-radius: 8px;
  background: ${({ $latestVersion, theme }) => ($latestVersion ? theme.tint.primary.light : theme.palette.grey[100])};
  cursor: pointer;
  text-align: left;
  transition: all 0.2s ease;

  &:hover {
    border: 1px solid ${({ theme }) => theme.palette.grey[200]};
    background: ${({ theme }) => theme.palette.common.white};
    box-shadow: 0 4px 20px 0 ${({ theme }) => theme.palette.grey[300]};
  }

  ${({ $isActive, $latestVersion, theme }) =>
    $isActive &&
    `
    color: ${theme.palette.common.black};
    border-color: ${$latestVersion ? 'none' : ' rgb(0, 123, 255)'};
    background: ${$latestVersion ? theme.tint.primary.light : theme.palette.common.white};
  `}

  span {
    display: block;
    font-size: 12px;
    color: ${({ theme }) => theme.palette.common.black};
    margin-top: 4px;
  }
`;

export const VersionsGroup = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px;
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const ActionButton = styled.button<{ $isPrimary?: boolean }>`
  flex: 1;
  padding: 10px 16px;
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  border-radius: 4px;
  background: white;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.palette.grey[100]};
    border-color: ${({ theme }) => theme.palette.grey[400]};
  }

  ${(props) =>
    props.$isPrimary &&
    `
    background: ${props.theme.palette.primary.main};
    color: white;
    border-color: ${props.theme.palette.primary.main};

    &:hover {
      background: #0056b3;
      border-color: #0056b3;
    }

    &:disabled {
      background: ${props.theme.palette.grey[400]};
      border-color: ${props.theme.palette.grey[400]};
      cursor: not-allowed;
    }
  `}
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
`;

export const ModalTitle = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 18px;
  font-weight: 500;
`;

export const ModalContent = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const VersionListPanel = styled.div`
  width: 320px;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const PreviewArea = styled.div`
  flex: 1;
  min-width: 0;
  position: relative;
  display: flex;
`;

export const PreviewLoading = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const PreviewPanel = styled.div<{ $hidden?: boolean }>`
  flex: 1;
  min-width: 0;
  overflow: auto;
  padding: 24px;
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};

  .tiptap {
    outline: none;
  }
`;
